import { lazyWithRetry } from "utils/lazyWithRetry";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { ROLE } from "utils/constants";
import { usePermissions } from "context/PermissionContext";
import { ProtectedElement } from "./ProtectedElement";
import LazyLoader from "components/lazyLoader";
import AppLayout from "layouts/AppLayout/AppLayout";
const Profile = lazyWithRetry(() => import("features/UserProfile"));
const Dashboard = lazyWithRetry(
  () => import("features/Client/Dashboard/Dashboard"),
);
const ClientRoles = lazyWithRetry(
  () => import("features/Client/AccessManagement/Roles/List"),
);
const AddClientRole = lazyWithRetry(
  () => import("features/Client/AccessManagement/Roles/AddRole"),
);
const ClientUsers = lazyWithRetry(
  () => import("features/Client/AccessManagement/Users/List"),
);
const AddClientUser = lazyWithRetry(
  () => import("features/Client/AccessManagement/Users/AddUser"),
);
const EditClientUser = lazyWithRetry(
  () => import("features/Client/AccessManagement/Users/EditUser"),
);

const UserActionHistory = lazyWithRetry(
  () =>
    import(
      "features/Client/LogsAndHistory/UserActionHistory"
    ),
);
const UserEmailLogs = lazyWithRetry(
  () => import("features/Client/LogsAndHistory/UserEmailLogsHistory/List"),
);

const DistributionTypes = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/DistributionType/DistributionTypes"),
);
const AddDistributionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/DistributionType/AddDistributionType"
    ),
);
const EditDistributionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/DistributionType/EditDistributionType"
    ),
);

const MaterialTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/MaterialType/MaterialTypes"),
);

const AddMaterialType = lazyWithRetry(
  () => import("features/Client/SystemSettings/MaterialType/AddMaterialType"),
);
const EditMaterialType = lazyWithRetry(
  () => import("features/Client/SystemSettings/MaterialType/EditMaterialType"),
);

const AddJurisdictionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/JurisdictionType/AddJurisdictionType"
    ),
);
const JurisdictionTypes = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/JurisdictionType/JurisdictionTypes"),
);
const EditJurisdictionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/JurisdictionType/EditJurisdictionType"
    ),
);

const VehicleTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/VehicleType/VehicleTypes"),
);
const AddVehicleType = lazyWithRetry(
  () => import("features/Client/SystemSettings/VehicleType/AddVehicleType"),
);
const EditVehicleType = lazyWithRetry(
  () => import("features/Client/SystemSettings/VehicleType/EditVehicleType"),
);

const TaxOrFeeTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/TaxOrFeeType/TaxOrFeeTypes"),
);

const AddTaxOrFeeType = lazyWithRetry(
  () => import("features/Client/SystemSettings/TaxOrFeeType/AddTaxOrFeeType"),
);
const EditTaxOrFeeType = lazyWithRetry(
  () => import("features/Client/SystemSettings/TaxOrFeeType/EditTaxOrFeeType"),
);

const RateTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/RateType/RateTypes"),
);
const AddRateType = lazyWithRetry(
  () => import("features/Client/SystemSettings/RateType/AddRateType"),
);
const EditRateType = lazyWithRetry(
  () => import("features/Client/SystemSettings/RateType/EditRateType"),
);

const ContainerTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/ContainerType/ContainerTypes"),
);

const AddContainerType = lazyWithRetry(
  () => import("features/Client/SystemSettings/ContainerType/AddContainerType"),
);
const EditContainerType = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/ContainerType/EditContainerType"),
);

const ContainerTypeOptions = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/ContainerTypeOptions/ContainerTypeOptions"
    ),
);

const AddContainerTypeOption = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/ContainerTypeOptions/AddContainerTypeOption"
    ),
);
const EditContainerTypeOption = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/ContainerTypeOptions/EditContainerTypeOption"
    ),
);

const ServiceTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/ServiceType/ServiceTypes"),
);

const AddServiceType = lazyWithRetry(
  () => import("features/Client/SystemSettings/ServiceType/AddServiceType"),
);
const EditServiceType = lazyWithRetry(
  () => import("features/Client/SystemSettings/ServiceType/EditServiceType"),
);

const CommodityTypeList = lazyWithRetry(
  () => import("features/Client/SystemSettings/CommodityType/CommodityTypes"),
);

const AddCommodityType = lazyWithRetry(
  () => import("features/Client/SystemSettings/CommodityType/AddCommodityType"),
);

const EditCommodityType = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/CommodityType/EditCommodityType"),
);

const SizeModelTypes = lazyWithRetry(
  () => import("features/Client/SystemSettings/SizeModelType/SizeModelTypes"),
);

const AddSizeModelType = lazyWithRetry(
  () => import("features/Client/SystemSettings/SizeModelType/AddSizeModelType"),
);

const EditSizeModelType = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/SizeModelType/EditSizeModelType"),
);

const RateDetailDescriptionTypes = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/RateDetailDescriptionType/RateDetailDescriptionTypes"
    ),
);

const AddRateDetailDescriptionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/RateDetailDescriptionType/AddRateDetailDescriptionType"
    ),
);
const EditRateDetailDescriptionType = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/RateDetailDescriptionType/EditRateDetailDescriptionType"
    ),
);

const DispatchAddress = lazyWithRetry(
  () => import("features/Client/SystemSettings/DispatchAddress"),
);
const AddDispatchAddress = lazyWithRetry(
  () =>
    import("features/Client/SystemSettings/DispatchAddress/AddDispatchAddress"),
);
const EditDispatchAddress = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/DispatchAddress/EditDispatchAddress"
    ),
);

const RouteMaintenanceList = lazyWithRetry(
  () => import("features/Client/RouteManagement/RouteMaintenance/List"),
);
const AddRouteMaintenance = lazyWithRetry(
  () =>
    import(
      "features/Client/RouteManagement/RouteMaintenance/AddRouteMaintenance"
    ),
);
const ViewRouteMaintenance = lazyWithRetry(
  () =>
    import(
      "features/Client/RouteManagement/RouteMaintenance/ViewRouteMaintenance"
    ),
);

const ScaleMasters = lazyWithRetry(
  () => import("features/Client/SystemSettings/ScaleMaster/List"),
);
const AddScaleMaster = lazyWithRetry(
  () => import("features/Client/SystemSettings/ScaleMaster/AddScaleMaster"),
);
const ViewScaleMaster = lazyWithRetry(
  () => import("features/Client/SystemSettings/ScaleMaster/ViewScaleMaster"),
);

const ScaleHouseMasters = lazyWithRetry(
  () => import("features/Client/SystemSettings/ScaleHouseMaster/List"),
);
const AddScaleHouseMaster = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/ScaleHouseMaster/AddScaleHouseMaster"
    ),
);
const ViewScaleHouseMaster = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/ScaleHouseMaster/ViewScaleHouseMaster"
    ),
);

const VehicleDetailsMasters = lazyWithRetry(
  () => import("features/Client/SystemSettings/VehicleDetailMaster/List"),
);
const AddVehicleDetailMaster = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/VehicleDetailMaster/AddVehicleDetailMaster"
    ),
);
const ViewVehicleDetailMaster = lazyWithRetry(
  () =>
    import(
      "features/Client/SystemSettings/VehicleDetailMaster/ViewVehicleDetailMaster"
    ),
);

const ServiceStopMaintenance = lazyWithRetry(
  () => import("features/Client/RouteManagement/ServiceStopMaintenance"),
);

const Coupons = lazyWithRetry(
  () => import("features/Client/Lockbox/CouponsBatch/List"),
);
const ManageCoupons = lazyWithRetry(
  () => import("features/Client/Lockbox/CouponsBatch/ManageCoupons"),
);
const ManageCouponsDraft = lazyWithRetry(
  () => import("features/Client/Lockbox/CouponsBatch/ManageCouponsDraft"),
);
const ManageCouponsEdit = lazyWithRetry(
  () => import("features/Client/Lockbox/CouponsBatch/ManageCouponsBatchEdit"),
);
const ManageCouponsView = lazyWithRetry(
  () => import("features/Client/Lockbox/CouponsBatch/ManageCouponsView"),
);

const LockboxBatch = lazyWithRetry(
  () => import("features/Client/Lockbox/LockboxBatch"),
);

const ReviewFailedRecords = lazyWithRetry(
  () => import("features/Client/Lockbox/LockboxBatch/ReviewFailedRecords"),
);
const ViewLockboxBatch = lazyWithRetry(
  () => import("features/Client/Lockbox/LockboxBatch/ViewLockboxBatch"),
);

const systemSettingsRoutes = [
  {
    path: "distribution-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <DistributionTypes /> },
      { path: "add", element: <AddDistributionType /> },
      { path: ":distributionTypeId", element: <EditDistributionType /> },
    ],
  },
  {
    path: "material-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <MaterialTypes /> },
      { path: "add", element: <AddMaterialType /> },
      { path: ":materialTypeId", element: <EditMaterialType /> },
    ],
  },
  {
    path: "vehicle-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <VehicleTypes /> },
      { path: "add", element: <AddVehicleType /> },
      { path: ":vehicleTypeId", element: <EditVehicleType /> },
    ],
  },
  {
    path: "tax-fee-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <TaxOrFeeTypes /> },
      { path: "add", element: <AddTaxOrFeeType /> },
      { path: ":taxFeeTypeId", element: <EditTaxOrFeeType /> },
    ],
  },
  {
    path: "rate-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <RateTypes /> },
      { path: "add", element: <AddRateType /> },
      { path: ":rateTypeId", element: <EditRateType /> },
    ],
  },
  {
    path: "container-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <ContainerTypes /> },
      { path: "add", element: <AddContainerType /> },
      { path: ":containerTypeId", element: <EditContainerType /> },
    ],
  },
  {
    path: "container-type-options",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <ContainerTypeOptions /> },
      { path: "add", element: <AddContainerTypeOption /> },
      {
        path: ":containerTypeOptionId",
        element: <EditContainerTypeOption />,
      },
    ],
  },
  {
    path: "jurisdictions",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <JurisdictionTypes /> },
      { path: "add", element: <AddJurisdictionType /> },
      { path: ":jurisdictionId", element: <EditJurisdictionType /> },
    ],
  },
  {
    path: "service-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <ServiceTypes /> },
      { path: "add", element: <AddServiceType /> },
      { path: ":serviceTypeId", element: <EditServiceType /> },
      { path: "view/:serviceTypeId", element: <EditServiceType /> },
    ],
  },
  {
    path: "commodity-types",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <CommodityTypeList /> },
      { path: "add", element: <AddCommodityType /> },
      { path: ":commodityTypeId", element: <EditCommodityType /> },
    ],
  },
  {
    path: "container-size-models",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <SizeModelTypes /> },
      { path: "add", element: <AddSizeModelType /> },
      { path: ":sizeModelId", element: <EditSizeModelType /> },
      { path: "view/:sizeModelId", element: <EditSizeModelType /> },
    ],
  },
  {
    path: "rate-detail-descriptions",
    permission: "MANAGE_MASTERS",
    routes: [
      { index: true, element: <RateDetailDescriptionTypes /> },
      { path: "add", element: <AddRateDetailDescriptionType /> },
      {
        path: ":rateDetailDescId",
        element: <EditRateDetailDescriptionType />,
      },
    ],
  },
  {
    path: "dispatch-address",
    permission: "MANAGE_DISPATCH_ADDRESS_MASTERS",
    routes: [
      { index: true, element: <DispatchAddress /> },
      { path: "add", element: <AddDispatchAddress /> },
      { path: ":dispatchAddressId", element: <EditDispatchAddress /> },
    ],
  },
  {
    path: "scale-master",
    permission: "MANAGE_SCALE",
    routes: [
      { index: true, element: <ScaleMasters /> },
      { path: "add", element: <AddScaleMaster /> },
      { path: "view/:scaleNumber", element: <ViewScaleMaster /> },
    ],
  },
  {
    path: "scale-house-master",
    permission: "MANAGE_SCALE",
    routes: [
      { index: true, element: <ScaleHouseMasters /> },
      { path: "add", element: <AddScaleHouseMaster /> },
      { path: "view/:scaleHouseId", element: <ViewScaleHouseMaster /> },
    ],
  },
  {
    path: "vehicle-details",
    permission: "MANAGE_VEHICLE_DETAIL",
    routes: [
      { index: true, element: <VehicleDetailsMasters /> },
      { path: "add", element: <AddVehicleDetailMaster /> },
      { path: "view/:vehicleDetailId", element: <ViewVehicleDetailMaster /> },
    ],
  },
];

const ClientRoutes = () => {
  const { clientPermissions } = usePermissions();

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute roles={[ROLE.client]}>
            {/* <IdleTimeoutProvider> */}
            <AppLayout />
            {/* </IdleTimeoutProvider> */}
          </ProtectedRoute>
        }
      >
        <Route
          path="dashboard"
          element={
            <LazyLoader>
              <Dashboard />
            </LazyLoader>
          }
        />
        <Route path="access-management">
          <Route index element={<Navigate to="users" replace />} />
          <Route
            path="roles"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_ROLE"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <ClientRoles />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddClientRole />
                </LazyLoader>
              }
            />
          </Route>

          <Route
            path="users"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_USER"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <ClientUsers />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddClientUser />
                </LazyLoader>
              }
            />
            <Route
              path="edit"
              element={
                <LazyLoader>
                  <EditClientUser />
                </LazyLoader>
              }
            />
          </Route>
        </Route>

        <Route path="log-history">
          <Route index element={<Navigate to="email" replace />} />
          <Route
            path="email"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["EMAIL_LOG"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <UserEmailLogs />
                </LazyLoader>
              }
            />
          </Route>
          <Route
            path="user"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["USER_ACTION_HISTORY"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <UserActionHistory />
                </LazyLoader>
              }
            />
          </Route>
        </Route>

        <Route path="system-settings">
          {systemSettingsRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedElement
                  element={<Outlet />}
                  requiredPermissions={[route.permission]}
                  assignedPermissions={clientPermissions}
                />
              }
            >
              {route.routes.map((subRoute, index) => (
                <Route
                  key={index}
                  index={subRoute.index}
                  path={subRoute.path}
                  element={<LazyLoader>{subRoute.element}</LazyLoader>}
                />
              ))}
            </Route>
          ))}
        </Route>
        <Route path="lockbox">
          <Route
            path="coupons"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_COUPON_BATCH"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <Coupons />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <ManageCoupons />
                </LazyLoader>
              }
            />
            <Route path=":batchNumber">
              <Route
                index
                element={
                  <LazyLoader>
                    <ManageCouponsView />
                  </LazyLoader>
                }
              />
              <Route
                path="draft"
                element={
                  <LazyLoader>
                    <ManageCouponsDraft />
                  </LazyLoader>
                }
              />
              <Route
                path="edit"
                element={
                  <LazyLoader>
                    <ManageCouponsEdit />
                  </LazyLoader>
                }
              />
            </Route>
          </Route>
          <Route
            path="lockbox-batch"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_LOCKBOX_BATCH"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <LockboxBatch />
                </LazyLoader>
              }
            />
            <Route
              path="failed-records/:fileSource/:batchId"
              element={
                <LazyLoader>
                  <ReviewFailedRecords />
                </LazyLoader>
              }
            />
            <Route
              path=":fileSource/:batchId"
              element={
                <LazyLoader>
                  <ViewLockboxBatch />
                </LazyLoader>
              }
            />
          </Route>
        </Route>

        <Route path="route-management">
          <Route
            path="route-maintenance"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_ROUTES"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <RouteMaintenanceList />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddRouteMaintenance />
                </LazyLoader>
              }
            />
            <Route
              path="view/:routeNumber"
              element={
                <LazyLoader>
                  <ViewRouteMaintenance />
                </LazyLoader>
              }
            />
          </Route>
        </Route>

        <Route path="transfer-station">
          <Route
            path="scale-master"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_SCALE"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <ScaleMasters />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddScaleMaster />
                </LazyLoader>
              }
            />
            <Route
              path="view/:scaleNumber"
              element={
                <LazyLoader>
                  <ViewScaleMaster />
                </LazyLoader>
              }
            />
          </Route>

          <Route
            path="scale-house-master"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_SCALE"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <ScaleHouseMasters />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddScaleHouseMaster />
                </LazyLoader>
              }
            />
            <Route
              path="view/:scaleHouseId"
              element={
                <LazyLoader>
                  <ViewScaleHouseMaster />
                </LazyLoader>
              }
            />
          </Route>

          <Route
            path="vehicle-details"
            element={
              <ProtectedElement
                element={<Outlet />}
                requiredPermissions={["MANAGE_VEHICLE_DETAIL"]}
                assignedPermissions={clientPermissions}
              />
            }
          >
            <Route
              index
              element={
                <LazyLoader>
                  <VehicleDetailsMasters />
                </LazyLoader>
              }
            />
            <Route
              path="add"
              element={
                <LazyLoader>
                  <AddVehicleDetailMaster />
                </LazyLoader>
              }
            />
            <Route
              path="view/:vehicleDetailId"
              element={
                <LazyLoader>
                  <ViewVehicleDetailMaster />
                </LazyLoader>
              }
            />
          </Route>
        </Route>

        <Route
          path="service-stop-maintenance"
          element={
            <ProtectedElement
              element={<Outlet />}
              requiredPermissions={["MANAGE_SERVICE_STOP"]}
              assignedPermissions={clientPermissions}
            />
          }
        >
          <Route
            index
            element={
              <LazyLoader>
                <ServiceStopMaintenance />
              </LazyLoader>
            }
          />
        </Route>

        <Route
          path="profile"
          element={
            <LazyLoader>
              <Profile />
            </LazyLoader>
          }
        />
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Route>
    </Routes>
  );
};

export default ClientRoutes;
